import { IDEA_STATUSES } from '@cult/domain';
import { z } from 'zod';

const STATUS_FILTER = z.enum(['', IDEA_STATUSES.KIV, IDEA_STATUSES.ACCEPTED, IDEA_STATUSES.CLOSED]).catch('');

export const feedSearchSchema = z.object({
  q: z.string().catch(''),
  status: STATUS_FILTER,
});

export type FeedSearch = z.infer<typeof feedSearchSchema>;
export type StatusFilter = z.infer<typeof STATUS_FILTER>;
